<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Bankdaten</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn
            block
            color="error"
            @click="deleteDialog = true"
            :disabled="edited == null ? false : edited.bankdaten.bankName!==''"
          >Bestellung stornieren</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn
            block
            color="primary"
            @click="forward"
            :disabled="edited == null ? false : edited.bankdaten.bankName!==''"
          >Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md12 lg6 pa-1>
          <v-data-table
            :headers="headers"
            :items="behandlungsorte"
            :sort-by="['name']"
            :sort-desc="[false]"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.bankdaten="{ item }">
              <div
                v-if="item.bankdaten.bankName!=='' && item.bankdaten.iban !=='' && item.bankdaten.bic !== '' && item.bankdaten.bankName!==null && item.bankdaten.iban !==null && item.bankdaten.bic !== ''"
              >ja</div>
              <div v-else>nein</div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon class="pa-1" @click="edit(item)">mdi-pencil</v-icon>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md12 lg6 pa-1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <h2 v-if="edited != null">Bankdaten {{edited.name}}</h2>
            <v-layout wrap v-if="edited != null">
              <v-flex xs12 sm6 md12 pa-1>
                <v-text-field
                  v-model="edited.bankdaten.bankName"
                  label="Bankname"
                  :rules="banknameRules"
                  :counter="255"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="edited.bankdaten.iban"
                  label="IBAN"
                  :rules="ibanRules"
                  :counter="34"
                  id="iban"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="edited.bankdaten.bic"
                  label="BIC"
                  :rules="bicRules"
                  :counter="11"
                  id="bic"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="edited != null">
              <v-spacer></v-spacer>
              <v-btn class="ma-2" color="error" @click="clear">Bearbeitung abbrechen</v-btn>
              <v-btn class="ma-2" color="primary" @click="save">Speichern</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bestellung wirklich stornieren?</v-card-title>
        <v-card-text>Das Stornieren der Bestellung kann nicht rückgängig gemacht werden.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Nein</v-btn>
          <v-btn color="blue darken-1" text @click="stopOrder">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<style>
#iban, #bic {
  text-transform: uppercase;
}
</style>
<script>
import { mapState } from "vuex";
function trimObjectValues(obj) {
  if (obj !== undefined && obj !== null) {
    Object.keys(obj).map(k => {
      var value = obj[k];
      if (value !== undefined && value !== null && typeof value == "string") {
        obj[k] = value.trim();
      } else if (value !== undefined && value !== null) {
        trimObjectValues(value);
      }
    });
  }
}
export default {
  data() {
    return {
      valid: false,
      deleteDialog: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Kürzel", value: "kuerzel" },
        { text: "BSNR", value: "bsnr" },
        { text: "Bankdaten vollständig", value: "bankdaten" },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      edited: null,
      banknameRules: [
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : !!v) || "Der Bankname darf nicht leer sein",
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : v.length <= 128) ||
              "Der Bankname muss kürzer als 128 Zeichen sein"
      ],
      ibanRules: [
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : !!v) || "Die IBAN darf nicht leer sein",
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : v.length <= 34) ||
              "Die IBAN muss kürzer als 34 Zeichen sein"
      ],
      bicRules: [
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : !!v) || "Die BIC darf nicht leer sein",
        v =>
          this.edited.hauptBehandlungsort === false
            ? false
            : (v === null ? false : v.length <= 11) ||
              "Die BIC darf nicht mehr als 11 Zeichen enthalten"
      ]
    };
  },
  computed: {
    ...mapState({
      behandlungsorte: state =>
        state.current.bestellung.lizenz.behandlungsorte.filter(
          ort => ort.hauptBehandlungsort
        ),
      process: state => state.current.process
    })
  },
  mounted: function() {
    if (this.$route.params.process != this.process) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  },
  watch: {
    behandlungsorte: function(nV, oV) {
      if (nV !== undefined && nV.length >= oV.length) {
        this.clear();
      }
    }
  },
  methods: {
    edit: function(ort) {
      const behandlungsort = JSON.parse(JSON.stringify(ort));
      this.edited = behandlungsort;
      this.$refs.form.resetValidation();
      this.$vuetify.goTo(0);
    },
    clear: function() {
      this.edited = null;
      this.$refs.form.resetValidation();
    },
    save: function() {
      if (this.$refs.form.validate()) {
        const behandlungsort = this.edited;
        behandlungsort.bankdaten.iban = behandlungsort.bankdaten.iban.toUpperCase();
        this.$store.commit("startLoading");
        trimObjectValues(behandlungsort);
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.bankdaten.BankdatenSaveRequestEvent",
          processId: this.$route.params.process,
          taskId: this.$route.params.task,
          id: behandlungsort.crmId,
          bankdaten: behandlungsort.bankdaten
        });
      }
    },
    stopOrder: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.bankdaten.BankdatenCancelRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    forward: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.bankdaten.BankdatenRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    }
  }
};
</script>
